import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranscriptComponent } from './transcript/transcript.component';
import { UserAvatarModule } from 'app/user-avatar/user-avatar.module';
import { TimeAgoModule } from 'app/pipes/time-ago/time-ago-pipe.module';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    declarations: [
        TranscriptComponent
    ],
    imports: [
        CommonModule,
        UserAvatarModule,
        TimeAgoModule,
        MatButtonModule,
        MatMenuModule
    ],
    exports: [
        TranscriptComponent
    ]
})
export class TranscriptModule { }
